import connect from 'components/Shared/connect';
import { ContentArea, Registry } from 'components/Shared/Markdown';
import { registry } from 'views/EditorialPage/components/registry';
import { isEditorialPage } from 'models/EditorialPageModel';

export default connect(state => ({
  content: isEditorialPage(state.currentPage) ? state.currentPage.content : []
}))(({ content }) => (
  <Registry registry={registry}>
    <ContentArea content={content} />
  </Registry>
));
